import React, { useEffect, useState, useContext, useRef } from "react";
import "./dash.css";
import { useNavigate } from "react-router-dom";
import Header from '../Header/Header'
import back from '../../Assets/back.svg'
import policydekhoicon from '../../Assets/pngwing.com (3).png'

const Dashboard = (props) => {

    const [role,setrole]=useState(JSON.parse(localStorage.getItem("userData")).Roles)
    console.log(role);
    const navigate = useNavigate();
    const [active, setactive] = useState(props.name);

    const changeactive = (value) => {
      setmenu(true)
      setactive(value);
    };
    const [menu,setmenu]=useState(false)
    const menuOpenClose=()=>{
      setmenu(!menu);
    }
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    useEffect(() => {
      if(screenWidth<880)
      {
        setmenu(true)
      }
    }, []);
      // setScreenWidth(window.innerWidth);
   

  return (
    <>
    <Header headtop={props.heading} openClose={menuOpenClose}/>
    <div className="theme1whitebg">
     {role=="Admin"?
      <div
        className="sidebar theme1whitebg position-relative "
        id={menu?"side_nav1":"sidenav2"}
        
        >
          <div className="text-end open-close  "><img onClick={()=>{setmenu(true)}} style={{cursor:"pointer"}} className="m-3" src={back} width={10} alt="" /></div>
        <div className="justify-content-center text-center">
            <img src={policydekhoicon} height={"80vw"} className="img" alt="" />
        </div>
        
        <div className="header-box w-100 " style={{overflowY:"auto"}} >
          <ul
            className="list-unstyled pt-2  justify-content-center accordion sidebar_ul "
            style={{
              // position:"relative",
              minHeight: "86vh",
              overflowY: "auto",
              overflowX: "hidden",
              zIndex: active !== null ? 1 : 0,
            }}
            id="main_accordian"
          >
            {/* -------------dasboard---------------- */}
            <li
              className={
              
                  "my-1  row justify-content-center"
              }
              onClick={() => {
                changeactive("dashboard");
                navigate("/ListOfService");
              }}
              data-bs-toggle="collapse"
              data-bs-target="#dashboardCollapse"
              aria-expanded="false"
              aria-controls="dashboardCollapse"
              role="button"
            >
              <div className={
                active === "dashboard"
                  ? "  col-7 col-lg-8 col-md-9 py-1 active rounded "
                  : "  col-7 col-lg-8 col-md-9 py-1 "
              } style={{ cursor: "pointer" }}>
                Dashboard
              </div>
            </li>

           {/* ================Employee================== */}
           <li
              className={
              
                  "my-1  row justify-content-center"
              }
              onClick={() => {
                changeactive("employee");
                navigate("/Employee");
              }}
              data-bs-toggle="collapse"
              data-bs-target="#dashboardCollapse"
              aria-expanded="false"
              aria-controls="dashboardCollapse"
              role="button"
            >
              <div className={
                active === "employee"
                  ? "  col-7 col-lg-8 col-md-9  py-1 active rounded"
                  : "  col-7 col-lg-8 col-md-9  py-1 "
              } style={{ cursor: "pointer" }}>
                Employee
              </div>
            </li>
            
</ul>

</div>
</div>
:""}
</div>
</>
  )
}

export default Dashboard